import { createFileRoute } from '@tanstack/react-router';
import ReviewPage from '@/features/resume-builder/review';

/** EU-762 RN-18..25 — "Revise suas informações" (pelo perfil, DEV-483). */
export const Route = createFileRoute('/perfil/curriculo/revisar')({
  component: ReviewPage,
});
